// This file was automatically generated from uiwidget.Form.html.
// Please don't edit this file by hand.

goog.provide('el8.template.uiwidget.Form');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.Form.input = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="textareaWrap lgFont"><input type="text" class="w100 ebs-form-control" name="', soy.$$escapeHtml(opt_data.name), '" /></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.Form.textarea = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="textareaWrap lgFont"><textarea type="text" class="w100 ebs-form-control" name="', soy.$$escapeHtml(opt_data.name), '" /></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.Form.react = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="', soy.$$escapeHtml(opt_data.containerId), '" class="', soy.$$escapeHtml(opt_data.containerClass), '"></div>');
  if (!opt_sb) return output.toString();
};
